import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=baf92f8a&scoped=true"
import script from "./Beneficios.vue?vue&type=script&lang=js"
export * from "./Beneficios.vue?vue&type=script&lang=js"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=baf92f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf92f8a",
  null
  
)

export default component.exports